package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import se.mittpass.shared.api.MyClaimDto

class ClaimsRepository(private val httpClient: HttpClient) {
    suspend fun claimSlot(slotId: Long, assign: Boolean = false): Result<Unit> = runCatching {
        httpClient.post("slots/$slotId/claim") {
            parameter("assign", assign)
        }
    }

    suspend fun unclaimSlot(slotId: Long): Result<Unit> = runCatching {
        httpClient.delete("slots/$slotId/claim")
    }

    suspend fun getMyClaims(): Result<List<MyClaimDto>> = runCatching {
        httpClient.get("my-claims").body()
    }
}
